export enum InvitationValidationResultType
{
    InvitationInvalid,
    InvitationExpired,
    InvitationUsed,
    InvitationValid
}